import { BiPlus } from 'react-icons/bi';

import s from './AddButton.module.scss';

type AddButtonProps = {
  /** Reads as "Add {label}" — pass the noun, not the whole sentence. */
  label: string;
  onClick(): void;
  disabled?: boolean;
};

const AddButton = ({ label, onClick, disabled = false }: AddButtonProps) => {
  return (
    <button className={s.addButton} onClick={onClick} type="button" disabled={disabled}>
      <span className={s.icon}>
        <BiPlus size={16} />
      </span>
      <span>Add {label}</span>
    </button>
  );
};

export default AddButton;
